import { render, staticRenderFns } from "./Individually.vue?vue&type=template&id=2c872e7b&"
import script from "./Individually.vue?vue&type=script&lang=js&"
export * from "./Individually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports